import { Typography } from '../../components/Typography'

import classes from './ParagraphRenderer.module.scss'

export const ParagraphRenderer = ({
  id,
  string
}: {
  id: string
  string: string | JSX.Element
}) => {
  return (
    <Typography className={classes.container} id={id}>
      {string}
    </Typography>
  )
}
